import { Dialog } from '@equinor/eds-core-react';
import styled from 'styled-components';

export const StyledDialog = styled(Dialog)`
  width: 1400px;
  max-width: 98vw;
  max-height: 92vh;
`;

export const Content = styled(Dialog.CustomContent)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 24px 32px;
`;

/** Full-width row: [form] [canvas] [proportions] */
export const ThreeColumnRow = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  flex-wrap: nowrap;
`;

/** Left column — area form */
export const FormColumn = styled.div`
  flex: 0 1 320px;
  min-width: 200px;
  padding-top: 2px;
`;
